<template>
  <div class="text-nowrap text-center">
    <span class="align-text-top text-capitalize">
      {{ value | moment("jYYYY/jMM/jD") }}
    </span>
    <br>
    <span style="color: #bdb1b1">{{ value | moment("HH:mm") }}</span>
  </div>
</template>

<script>
export default {
  name: 'DateCell',
  props: ['value'],

}
</script>
